import React, { useEffect, useState } from "react";
import { Fields } from "uicomponents";
import { helpers } from "services";
import qs from "query-string";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import useAccess from "../../../hooks/useAccess";
import useTranslation from "../../../hooks/useTranslation";

const Filter = ({ showFilterModal }) => {
	const { tr } = useTranslation();

	const isCashier = useAccess({ roles: ["cashier"] });

	const location = useLocation();
	const navigate = useNavigate();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });

	const [paymentTypes, setPaymentTypes] = useState([]);
	const [type, setType] = useState(null);
	const [status, setStatus] = useState(null);
	const [orderNumber, setOrderNumber] = useState("");
	const [client, setClient] = useState(null);
	const [author, setAuthor] = useState(null);
	const [dishes, setDishes] = useState([]);
	const [courier, setCourier] = useState();
	const [isRemovedGoods, setIsRemovedGoods] = useState(0);

	const clearHandler = () => {
		setType(null);
		setStatus(null);
		setOrderNumber("");
		setClient(null);
		setAuthor(null);
		setDishes([]);
		setCourier(null);
		setPaymentTypes([]);
		setIsRemovedGoods(0);

		navigate({
			search: qs.stringify(
				{
					...(query.start_at ? { start_at: query.start_at } : {}),
					...(query.end_at ? { end_at: query.end_at } : {})
				},
				{ encode: false }
			)
		});
		showFilterModal(false);
	};

	const handleSubmit = () => {
		const { page, ...restQuery } = query;
		let values = {
			...restQuery,
			type,
			status,
			orderNumber,
			client: client ? client.id + "/" + client.name : null,
			courier: courier ? courier.id + "/" + courier.name : null,
			author: author ? author.id + "/" + author.name : null,
			dishes:
				dishes.length > 0
					? dishes
						.reduce((prev, curr) => [...prev, curr.id + "/" + curr.name], [])
						.join(",")
					: "",
			paymentTypes:
				paymentTypes.length > 0
					? paymentTypes
						.reduce((prev, curr) => [...prev, curr.id + "/" + curr.name], [])
						.join(",")
					: "",
			with_removed_goods: isRemovedGoods ? 1 : 0
		};
		values = Object.keys(values).reduce(
			(prev, curr) =>
				values[curr] != null && values[curr] !== "" ? { ...prev, [curr]: values[curr] } : { ...prev },
			{}
		);

		navigate({
			search: qs.stringify(values, { encode: false })
		});
		showFilterModal(false);
	};

	useEffect(() => {
		setDishes(
			query.dishes
				? query.dishes.split(",").reduce(
					(prev, curr) => [
						...prev,
						{
							id: curr.split("/")[0],
							name: curr.split("/")[1]
						}
					],
					[]
				)
				: []
		);
		setPaymentTypes(
			query.paymentTypes
				? query.paymentTypes.split(",").reduce(
					(prev, curr) => [
						...prev,
						{
							id: curr.split("/")[0],
							name: curr.split("/")[1]
						}
					],
					[]
				)
				: []
		);
		setType(query.type ? Number(query.type) : null);
		setStatus(query.status ? query.status : null);
		setOrderNumber(query.orderNumber ? query.orderNumber : null);
		setClient(
			query.client
				? { id: query.client.split("/")[0], name: query.client.split("/")[1] }
				: null
		);
		setCourier(
			query.courier
				? { id: query.courier.split("/")[0], name: query.courier.split("/")[1] }
				: null
		);
		setAuthor(
			query.author
				? { id: query.author.split("/")[0], name: query.author.split("/")[1] }
				: null
		);
		setIsRemovedGoods(
			query.with_removed_goods !== undefined
				? Number(query.with_removed_goods)
					? 1
					: 0
				: 0
		);
	}, []);

	return (
		<div className="pad-30" style={{ overflow: "scroll", height: "100%" }}>
			<div className="fs-18 mb-30">{tr("Фильтр заказов")}</div>
			<div className="flex-1">
				<Fields.InputS1Default
					label={tr("Номер заказа")}
					size={"small"}
					placeholder={tr("Введите номер заказа")}
					value={orderNumber}
					onChange={e => setOrderNumber(e.target.value)}
				/>
			</div>

			<div className="flex-1">
				<Fields.SelectD1
					size={"small"}
					label={tr("Тип заказа")}
					value={type}
					isClearable={true}
					optionValue={"value"}
					optionLabel={"label"}
					onChangeHandle={option => {
						if (option) {
							setType(option.value);
						} else {
							setType(null);
						}
					}}
					options={helpers.orderTypesList(tr)}
					placeholder={tr("Выберите тип заказа")}
				/>
			</div>
			{/* {type === 3 && (
				<Fields.AsyncSelectD1
					type="text"
					placeholder={tr("Выберите")}
					label={tr("Клиент номер")}
					loadOptionsUrl={"/dishes"}
					optionLabel="name"
					isSearchable={true}
					isClearable={true}
					isMulti={true}
					size={"small"}
					className={"flex-1"}
					handleChange={option => {
						if (option) {
							setDishes(option);
						} else {
							setDishes([]);
						}
					}}
					value={dishes}
					loadOptionsParams={search => {
						return {
							extra: { _query: search }
						};
					}}
				/>
			)} */}

			<Fields.AsyncSelectD1
				type="text"
				placeholder={tr("Выберите")}
				label={tr("Продукт")}
				loadOptionsUrl={"/dishes"}
				optionLabel="name"
				isSearchable={true}
				isClearable={true}
				isMulti={true}
				size={"small"}
				className={"flex-1"}
				handleChange={option => {
					if (option) {
						setDishes(option);
					} else {
						setDishes([]);
					}
				}}
				value={dishes}
				loadOptionsParams={search => {
					return {
						extra: { _query: search }
					};
				}}
			/>

			<Fields.AsyncSelectD1
				type="text"
				placeholder={tr("Выберите")}
				label={tr("Тип оплаты")}
				loadOptionsUrl={"/payment-types"}
				optionLabel="name"
				isSearchable={true}
				isClearable={true}
				isMulti={true}
				size={"small"}
				className={"flex-1"}
				handleChange={option => {
					if (option) {
						setPaymentTypes(option);
					} else {
						setPaymentTypes([]);
					}
				}}
				value={paymentTypes}
				loadOptionsParams={search => {
					return {
						extra: { _query: search }
					};
				}}
			/>

			<div>
				<Fields.AsyncSelectD1
					type="text"
					placeholder={tr("Выберите")}
					label={tr("Клиент")}
					loadOptionsUrl={"/user/all"}
					optionLabel="name"
					isSearchable={true}
					isClearable={true}
					size={"small"}
					className={"flex-1"}
					handleChange={option => {
						if (option) {
							setClient(option);
						} else {
							setClient(null);
						}
					}}
					value={client}
					loadOptionsParams={search => {
						return {
							filter: {
								type: config.USER_TYPE_CLIENT
							},
							sort: "name",
							extra: { name: search }
						};
					}}
				/>
			</div>

			{!isCashier && (
				<div>
					<Fields.AsyncSelectD1
						type="text"
						placeholder={tr("Выберите")}
						label={tr("Автор")}
						loadOptionsUrl={"/user/all"}
						optionLabel="name"
						isSearchable={true}
						isClearable={true}
						size={"small"}
						className={"flex-1"}
						handleChange={option => {
							if (option) {
								setAuthor(option);
							} else {
								setAuthor(null);
							}
						}}
						value={author}
						loadOptionsParams={search => {
							return {
								sort: "name",
								extra: {
									name: search,
									roles: `${config.USER_ROLE_WAITER},${config.USER_ROLE_CASHIER}`
								}
							};
						}}
					/>
				</div>
			)}
			<div>
				<Fields.AsyncSelectD1
					type="text"
					placeholder={tr("Выберите")}
					label={tr("Курьер")}
					loadOptionsUrl={"/user/all"}
					optionLabel="name"
					isSearchable={true}
					isClearable={true}
					size={"small"}
					className={"flex-1"}
					handleChange={option => {
						if (option) {
							setCourier(option);
						} else {
							setCourier(null);
						}
					}}
					value={courier}
					loadOptionsParams={search => {
						return {
							filter: {
								"role.role": "courier"
							},
							sort: "name",
							extra: { name: search }
						};
					}}
				/>
			</div>

			<div className="flex-1">
				<Fields.SelectD1
					size={"small"}
					label={tr("Статус заказа")}
					value={status}
					isClearable={true}
					optionValue={"value"}
					optionLabel={"label"}
					onChangeHandle={option => {
						if (option) {
							setStatus(option.value);
						} else {
							setStatus(null);
						}
					}}
					options={helpers.orderStatus(tr)}
					placeholder={tr("Выберите статус заказа")}
				/>
			</div>
			<div className="flex-1">
				<label
					htmlFor="with_removed_goods"
					style={{ display: "flex", alignItems: "center", gap: 8 }}
				>
					<input
						id="with_removed_goods"
						name="with_removed_goods"
						type="checkbox"
						checked={!!isRemovedGoods}
						onChange={e => setIsRemovedGoods(e.target.checked ? 1 : 0)}
					/>
					{tr("Показать удалённые блюди")}
				</label>
			</div>
			<div className="mt-50">
				<button
					onClick={handleSubmit}
					type="submit"
					className={`d-btn d-btn--small d-btn-primary d-btn--full mb-10`}
				>
					{tr("Фильтровать")}
				</button>
				<button
					onClick={clearHandler}
					type="button"
					className={`d-btn d-btn--small d-btn-danger-outline d-btn--full`}
				>
					{tr("Очистить")}
				</button>
			</div>
		</div>
	);
};

export default Filter;
